module.exports = "<div class=\"schedule-quickstart\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/schedule-quickstart.component.html
// module id = 1594
// module chunks = 2